import { render, staticRenderFns } from "./paging.vue?vue&type=template&id=216181f5&scoped=true"
import script from "./paging.vue?vue&type=script&lang=js"
export * from "./paging.vue?vue&type=script&lang=js"
import style0 from "./paging.vue?vue&type=style&index=0&id=216181f5&prod&scoped=true&lang=css"
import style1 from "./paging.vue?vue&type=style&index=1&id=216181f5&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216181f5",
  null
  
)

export default component.exports